export const MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL = {
  MonthlyPot: 'MonthlyPot',
  PeriodUsageProportional: 'PeriodUsageProportional',
};

export const DEFAULT_MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL =
  MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL.MonthlyPot;

export const normalizeMembershipRevenueDistributionModel = (value) => {
  const normalized = String(value ?? '').replace(/\s+/g, '');
  if (normalized === MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL.PeriodUsageProportional || normalized === '2') {
    return MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL.PeriodUsageProportional;
  }
  return MEMBERSHIP_REVENUE_DISTRIBUTION_MODEL.MonthlyPot;
};
